import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PermissionService } from '../../../core/authorization/permission';

interface MenuItem {
    label               : string;
    icon                : string;
    route               : string;
    requiredPermission? : string;
    canView$?           : Observable<boolean>;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatListModule, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css'
})
export class Sidebar implements OnInit {
	rawMenuItems = [
		{ label: 'Dashboard', icon: 'home', route: '/dashboard'},
    	{ label: 'Gestión de Permisos', icon: 'key', route: '/permissions', requiredPermission: 'permissions.read' },
		{ label: 'Gestión de Roles', icon: 'assignment_ind', route: '/roles', requiredPermission: 'roles.read' },
		{ label: 'Gestión de Usuarios', icon: 'people', route: '/users', requiredPermission: 'users.read' },
		{ label: 'Gestión de Entidades', icon: 'apartment', route: '/entities', requiredPermission: 'entities.read' },
		{ label: 'Gestión de Rutas', icon: 'alt_route', route: '/routes', requiredPermission: 'routes.read' },
		{ label: 'Gestión de Clientes', icon: 'person_add', route: '/partners', requiredPermission: 'partners.read' },
		{ label: 'Gestión de Flota', icon: 'directions_bus', route: '/buses', requiredPermission: 'buses.read' },
		{ label: 'Descuentos', icon: 'local_offer', route: '/discounts', requiredPermission: 'discounts.read' },
		{ label: 'Liquidaciones', icon: 'receipt_long', route: '/liquidations', requiredPermission: 'liquidations.read' },
		{ label: 'Reportes', icon: 'assessment', route: '/reports' },
		{ label: 'Importador de Datos', icon: 'cloud_upload', route: '/data-importer', requiredPermission: 'dataImporter.read' },
		{ label: 'Configuración General', icon: 'settings', route: '/general-settings', requiredPermission: 'generalSettings.read' },
		{ label: 'Área de Pruebas', icon: 'code', route: '/tests', requiredPermission: 'tests.read' },
	];

	menuItems: (MenuItem & { canView$: Observable<boolean> })[] = [];

	constructor(private permissionService: PermissionService) {}

	ngOnInit(): void {
		this.menuItems = this.rawMenuItems.map(item => ({
            ...item,
            canView$: item.requiredPermission ? this.permissionService.hasPermission(item.requiredPermission) : of(true)
        }));
	}
}
